import { Injectable } from "@angular/core";
import { ServiceStock } from "./service-stock.service";
import { HttpProviderService } from "./fpx-core";
import { HttpClient } from "@angular/common/http";
import { AppInitService } from "./services/app-init.service";
import { CommonService } from "./common.service";

// const ACTIVITY_TIMEOUT_PERIOD=  100000; //30mins
// const ACTIVITY_TIMEOUT_WARNING_BEFORE= 15000 ; //15 sec
@Injectable({
  providedIn: "root",
})
export class ActivityMonitor {
  private monitorTimeoutHandle: any = null;
  private dismissTimeoutHandle: any = null;
  private displayUserPrompt;
  private dismissUserPrompt;
  private warningTimer: boolean = false;

  /*SANTHOSH 20-OCT-2021 BEGIN */
  private waitForUserActionStartDatetime: number;
  private waitForUserAction: boolean;
  private lastActivityDatetime: number = 0;
  /*SANTHOSH 20-OCT-2021 END */
  idleTimeout: any;
  idleTimeoutPromptB4Sec: any;
  /*SANTHOSH 15-DEC-2021 BEGIN */
  private activityTimeoutHandle: any = null;
  private logoutProgress: number = 0;
  /*SANTHOSH 15-DEC-2021 END */
  ACTIVITY_TIMEOUT_PERIOD; //30mins
  ACTIVITY_TIMEOUT_WARNING_BEFORE; //15 sec
  constructor(
    private services: ServiceStock,
    private httpService: HttpProviderService,
    public appInit: AppInitService,
    private httpClient: HttpClient,
    private _commonService: CommonService
  ) {
    this.configData();
  }
  configData() {
    let data = this.appInit.keysValues;
    this.ACTIVITY_TIMEOUT_PERIOD = (data.idleTimeoutInMin) * 60 * 1000;
    this.ACTIVITY_TIMEOUT_WARNING_BEFORE = (data.idleTimeoutPromptB4Sec) * 1000;
  }

  startMonitor(displayUserPrompt = () => {}, dismissUserPrompt = () => {}) {
    this.displayUserPrompt = displayUserPrompt;
    this.dismissUserPrompt = dismissUserPrompt;
    document.addEventListener(
      "touchstart",
      this.doActivityMonitor.bind(this),
      false
    );
    document.addEventListener(
      "touchmove",
      this.doActivityMonitor.bind(this),
      false
    );
    document.addEventListener(
      "touchend",
      this.doActivityMonitor.bind(this),
      false
    );
    document.addEventListener(
      "keypress",
      this.doActivityMonitor.bind(this),
      false
    );
    /*SANTHOSH 15-DEC-2021 BEGIN */
    document.addEventListener(
      "mousemove",
      this.doActivityMonitor.bind(this),
      false
    );
    /*SANTHOSH 15-DEC-2021 END */
    this.continueAndMonitor();
  }

  public checkAndLogout() {
    if (this.services.dataStore.isUserLoggedIn()) {
      let currentDateTime = new Date().getTime();
      if (this.waitForUserAction) {
        let elapsed = currentDateTime - this.waitForUserActionStartDatetime;
        if (elapsed > this.ACTIVITY_TIMEOUT_WARNING_BEFORE) {
          this.dissmissAndExit();
        }
      } else {
        let elapsed = currentDateTime - this.lastActivityDatetime;
        if (elapsed > this.ACTIVITY_TIMEOUT_PERIOD) {
          this.dissmissAndExit();
        }
      }
    }
  }

  private warnAndCheck() {
    if (this.services.dataStore.isUserLoggedIn()) {
      let currentDateTime = new Date().getTime();
      let elapsed = currentDateTime - this.lastActivityDatetime;
      if (elapsed > this.ACTIVITY_TIMEOUT_PERIOD) {
        console.log("Activity Timeout Expired");
        this.dissmissAndExit();
      } else {
        console.log("Display User Prompt");
        this.dismissTimeoutHandle = setTimeout(() => {
          console.log("Warning Period Elapsed");
          this.dissmissAndExit();
        }, this.ACTIVITY_TIMEOUT_WARNING_BEFORE);
        console.log("Session Exit Warning");
        /*SANTHOSH 20-OCT-2021 BEGIN*/
        this.waitForUserAction = true;
        this.waitForUserActionStartDatetime = new Date().getTime();
        /*SANTHOSH 20-OCT-2021 END*/
        this.displayUserPrompt();
      }
    } else {
      this.continueAndMonitor();
    }
  }

  dissmissAndExit() {
    console.log("Session Dismissed");
    /*SANTHOSH 20-OCT-2021 BEGIN */
    this.waitForUserAction = false;
    /*SANTHOSH 20-OCT-2021 END */
    var paths
    if(this._commonService.isHybrid()){
       paths = window.location.href.split("/index.html#/")[1];
    }else{
       paths = window.location.href.split("/#/")[1];
    }
    
    if (paths && paths?.match("newAccountOpening")) {
      sessionStorage.setItem("inAccOpeningWay", "1");
    }
    this.dismissUserPrompt();
  }

  /*SANTHOSH 20-OCT-2021 BEGIN */
  continueSession() {
    console.log("Session Continued");
    this.waitForUserAction = false;
    this.continueAndMonitor();
  }
  /*SANTHOSH 20-OCT-2021 END */

  private continueAndMonitor() {
    /*SANTHOSH 20-OCT-2021 BEGIN */
    this.lastActivityDatetime = new Date().getTime();
    /*SANTHOSH 20-OCT-2021 END */
    this.warningTimer = false;
    if (!this.waitForUserAction) {
      if (this.dismissTimeoutHandle) {
        clearTimeout(this.dismissTimeoutHandle);
        this.dismissTimeoutHandle = null;
        console.log("Cancel Dismiss Timeout Handle");
      }
    }
    if (this.monitorTimeoutHandle) {
      clearTimeout(this.monitorTimeoutHandle);
      // console.log("Activity Reset");
    }
    /*SANTHOSH 15-DEC-2021 BEGIN */
    if (this.activityTimeoutHandle) {
      clearTimeout(this.activityTimeoutHandle);
    }

    this.activityTimeoutHandle = setTimeout(() => {
      this.updateLogoutPeriod();
    }, 1000);
    /*SANTHOSH 15-DEC-2021 END */
    this.monitorTimeoutHandle = setTimeout(() => {
      this.warnAndCheck();
    }, this.ACTIVITY_TIMEOUT_PERIOD - this.ACTIVITY_TIMEOUT_WARNING_BEFORE);
  }

  /*SANTHOSH 15-DEC-2021 BEGIN */

  private getLogoutProgress() {
    return this.logoutProgress;
  }
  private updateLogoutPeriod() {
    let currentDatetime = new Date().getTime();
    let elapsed = currentDatetime - this.lastActivityDatetime;
    let remaining = this.ACTIVITY_TIMEOUT_PERIOD - elapsed;
    if (remaining > 0) {
      this.logoutProgress = Math.floor(
        (elapsed / this.ACTIVITY_TIMEOUT_PERIOD) * 100
      );
      remaining = Math.floor(remaining / 1000);
      var m: any = Math.floor(remaining / 60);
      var s: any = remaining % 60;

      m = m < 10 ? "0" + m : m;
      s = s < 10 ? "0" + s : s;
      let remainingTime = m + ":" + s;
      if (document.getElementById("logoutTimer")) {
        document.getElementById("logoutTimer").innerHTML = m + ":" + s;
      }
      setTimeout(() => {
        //console.log("Logout Timer Update Triggered");
        this.updateLogoutPeriod();
      }, 1000);
    }
  }
  /*SANTHOSH 15-DEC-2021 END */

  private doActivityMonitor() {
    // console.log("Activity Detected");
    this.continueAndMonitor();
  }

  /*SANTHOSH 20-OCT-2021 BEGIN */
  updateWarningTime() {
    console.log("Warning Date And Time Update");
    let currentDatetime = new Date().getTime();
    let elapsed = currentDatetime - this.waitForUserActionStartDatetime;
    let remaining = this.ACTIVITY_TIMEOUT_WARNING_BEFORE - elapsed;
    if (remaining > 0) {
      remaining = Math.floor(remaining / 1000);
      var m: any = Math.floor(remaining / 60);
      var s: any = remaining % 60;

      m = m < 10 ? "0" + m : m;
      s = s < 10 ? "0" + s : s;
      let remainingTime = m + ":" + s;
      document.getElementById("sessionTimer").innerHTML = m + ":" + s;
      if (this.waitForUserAction) {
        console.log("User Prompt Open. Schedule Timer Update");
        setTimeout(() => {
          console.log("Timer Update Triggered");
          this.updateWarningTime();
        }, 1000);
      }
    } else {
      console.log("No Warning Time Remaining");
    }
  }
  /*
  updateWarningTime(remaining:any = undefined) {
    if(!remaining){
      this.warningTimer = true;
      remaining = ACTIVITY_TIMEOUT_WARNING_BEFORE / 1000;
    }
    var _this = this;
    var m: any = Math.floor(remaining / 60);
    var s: any = remaining % 60;

    m = m < 10 ? '' + m : m;
    s = s < 10 ? '0' + s : s;
    document.getElementById('sessionTimer').innerHTML = m + ':' + s;
    remaining--;

    if (remaining > 0 && this.warningTimer) {
      setTimeout(function () {
        _this.updateWarningTime(remaining);
      }, 1000);
      return;
    } else {
      //TODO: logout
      this.warningTimer = false;
    }
  }
  */
  /*SANTHOSH 20-OCT-2021 END */

  exitWarningTimer() {}

  stopMonitor() {
    /*SANTHOSH 30/09/2021 BEGIN*/
    document.removeEventListener(
      "touchstart",
      this.doActivityMonitor.bind(this),
      false
    );
    document.removeEventListener(
      "touchmove",
      this.doActivityMonitor.bind(this),
      false
    );
    document.removeEventListener(
      "touchend",
      this.doActivityMonitor.bind(this),
      false
    );
    document.removeEventListener(
      "keypress",
      this.doActivityMonitor.bind(this),
      false
    );
    /*SANTHOSH 30/09/2021 END*/
  }
}
